import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import {
  getIPexHumanCapitalPage1Components,
  getIPexHumanCapitalPage2Components,
} from './i-pex-human-capital-chart-helpers';

const dashboardId = 'i_pex_human_capital_dashboard';

export const IPexHumanCapitalDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'Human Capital Dashboard',
    [Languages.JA]: '人的資本ダッシュボード',
  },
  enabled: true,
  pages: [
    {
      pageId: '1',
      dashboardId,
      pageNumber: 1,
      enabled: true,
      title: {
        [Languages.EN]: 'Basic Information',
        [Languages.JA]: '基本情報',
      },
      pageOptions: {
        displayOptions: {
          enabled: true,
        },
        timeOptions: {
          timeSliderEnabled: false,
          useLatestWarehouseMonth: true,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 3,
      gridRows: 2,
      configType: 'componentConfigs',
      components: getIPexHumanCapitalPage1Components,
    },
    {
      pageId: '2',
      dashboardId,
      pageNumber: 2,
      enabled: true,
      title: {
        [Languages.EN]: 'Workforce Composition',
        [Languages.JA]: '人員構成',
      },
      pageOptions: {
        displayOptions: {
          enabled: true,
        },
        timeOptions: {
          timeSliderEnabled: false,
          useLatestWarehouseMonth: true,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 3,
      gridRows: 2,
      configType: 'componentConfigs',
      components: getIPexHumanCapitalPage2Components,
    },
  ],
};
